<div
  *ngIf="isVisible"
  class="relative z-30 overflow-y-auto"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0 p-4"
    >
      <div
        class="px-4 pt-4 pb-2 relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl"
      >
        <div>
          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button
              type="button"
              (click)="close()"
              class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
            >
              <span class="sr-only">Close</span>
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-4 py-4 lg:px-2 lg:py-4"> <!-- px-4 py-4 lg:px-6 lg:py-6 -->
            <div class="mt-3 sm:mt-0 w-full">
              <h3
                class="text-2xl text-gray-700 font-extrabold leading-6"
                [ngClass]="titleColor"
                id="modal-title"
              >
                {{ title }}
              </h3>

              <ng-content></ng-content>

              <div
                [ngClass]="{
                  'justify-between items-center': buttons.length === 2,
                  'justify-center': buttons.length === 1
                }"
                class="sm:px-0 flex sm:flex-row flex-col-reverse w-full gap-y-3 sm:space-x-5 pt-6"
              >
                <ng-container *ngFor="let button of buttons">
                  <button
                    type="button"
                    class="w-full btn disabled:opacity-50 disabled:cursor-not-allowed"
                    [ngClass]="button.class"
                    [disabled]="evaluateDisabled(button)"
                    (click)="button.action()"
                  >
                    {{ button.text }}
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
